import { isCompleteConfiguration } from './configuration-utils';
import { isErrorResponse } from './create-buildable';
import { KEYS_IN_ORDER } from './keys';
import { normalizeConfiguration } from './normalize';
import { BuildabilityStatusV2 as BuildabilityStatus } from './types';
export const createKey = (_configuration) => {
    if (!_configuration) {
        return '';
    }
    const configuration = normalizeConfiguration(_configuration);
    const buffer = KEYS_IN_ORDER.map(key => configuration[key] || '');
    const options = [...(configuration.options || [])].sort();
    buffer.push(options.join('$'));
    return buffer.join(':');
};
export function isEqual(value, compare) {
    return createKey(value) === createKey(compare);
}
export class BuildabilityCache {
    constructor() {
        this.cache = new Map();
    }
    get(configuration) {
        const key = createKey(configuration);
        return this.cache.get(key);
    }
    putStatus(configuration, buildabilityStatus) {
        if (buildabilityStatus) {
            this.put(configuration, { buildabilityStatus });
        }
    }
    putResult(configuration, response) {
        if (!response) {
            return;
        }
        let buildabilityStatus;
        if (isErrorResponse(response)) {
            buildabilityStatus = BuildabilityStatus.NOT_BUILDABLE;
        }
        else if (createKey(configuration) === createKey(response.configuration)) {
            buildabilityStatus = BuildabilityStatus.BUILDABLE;
        }
        else if (isCompleteConfiguration(configuration)) {
            buildabilityStatus = BuildabilityStatus.NOT_BUILDABLE;
        }
        else {
            buildabilityStatus = BuildabilityStatus.INCOMPLETE;
        }
        this.put(configuration, {
            result: response,
            buildabilityStatus
        });
    }
    size() {
        return this.cache.size;
    }
    clear() {
        this.cache.clear();
    }
    put(configuration, cacheItem) {
        const key = createKey(configuration);
        if (!Boolean(key && cacheItem)) {
            return;
        }
        this.cache.set(key, cacheItem);
    }
}
